function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), React.createElement("path", {
    style: {
      "fill": "#7d7d7d"
    },
    d: "M12.479,7.916h-1.3a.592.592,0,0,0-.577.48,3.52,3.52,0,0,1-3.459,3.122A3.54,3.54,0,0,1,3.46,7.844,3.159,3.159,0,0,1,6.7,4.85V6.482a.363.363,0,0,0,.586.286l3.766-2.932a.5.5,0,0,0,0-.783L7.291.079A.363.363,0,0,0,6.7.364v1.8a5.877,5.877,0,0,0-5.7,5.688A6.005,6.005,0,0,0,13,8.451.509.509,0,0,0,12.479,7.916Z"
  }));
};
export default __webpack_public_path__ + "static/media/reload.8b9b7983.svg";
export { SvgComponent as ReactComponent };